import AntDIcon from 'antd/lib/icon'
import React from 'react'

const Icon = ({ size }) => {
  const SVG = () => (
    <svg
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M12 4V1M12 4C10.1435 4 8.36301 4.7375 7.05025 6.05025C5.7375 7.36301 5 9.14348 5 11M12 4L9 1M12 20V23M12 20C13.8565 20 15.637 19.2625 16.9497 17.9497C18.2625 16.637 19 14.8565 19 13M12 20L15 23M5 11H2M5 11L2 8M19 13H22M19 13L22 16'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
  return <AntDIcon component={SVG} />
}
export default Icon
